$(document).ready(function () {
    if ($("#cookiePopup").length > 0) {
        window.onload = () => {
            setTimeout(() => {
                checkAcceptCookies();
            }, 3000);
        };
    }
});

function checkAcceptCookies() {
    if (Cookies.get('Cookie_Accept') !== 'true') {
        $('#cookiePopup').addClass('showCookies');
    }
}

window.acceptCookies = function () {
    Cookies.set('Cookie_Accept', 'true'), {expires: 7};
    $('#cookiePopup').hide();
}





